import React, { memo } from 'react';
import { Divider } from 'semantic-ui-react';
import { CONSULT_TYPE_FOLLOW_UP } from '../../../../../../constants/consults';

const ConsultDivider = ({ consultType }) => (
  <Divider horizontal>
    {consultType === CONSULT_TYPE_FOLLOW_UP ? 'Follow-up Consult' : 'New Consult'}
  </Divider>
);

export default memo(ConsultDivider);
